"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGo1ContentView = void 0;
const React = require("react");
const react_1 = require("react");
const constants_1 = require("../../common/constants");
const params_1 = require("../../common/params");
function useGo1ContentView(props) {
    const { feature, featureAttributes, portalURL, oneTimeToken, onGo1MessageReceived, additionalUserInfo, themeInformation, env = 'production', } = props;
    const iframeRef = (0, react_1.useRef)(null);
    let url = 'https://embedding.go1.com';
    if (env === 'staging') {
        url = 'https://embedding.qa.go1.cloud';
    }
    if (!(0, params_1.isValidFeature)(feature)) {
        throw new Error('Unsupported feature');
    }
    const sendMessageToGo1 = (0, react_1.useCallback)((message) => {
        iframeRef.current?.contentWindow?.postMessage(message, url);
    }, [url]);
    let { iframeURL, iframeID } = (0, react_1.useMemo)(() => {
        let iframeURL = new URL(`${url}/${feature}`);
        if (portalURL) {
            (0, params_1.addPortalURL)(iframeURL, portalURL, env);
        }
        if (oneTimeToken) {
            (0, params_1.addOneTimeToken)(iframeURL, oneTimeToken);
        }
        const iframeID = `go1-iframe-${feature}`;
        return { iframeURL, iframeID };
    }, [url, feature, portalURL, oneTimeToken, env]);
    const eventListenerInstance = (0, react_1.useCallback)((event) => {
        const { _type, ...rest } = event.data;
        if (_type === constants_1.GO1_MESSAGE) {
            if (rest.type === 'go1_app_initialised') {
                let payload = {
                    additionalUserInfo,
                    themeInformation,
                    featureAttributes,
                };
                sendMessageToGo1({
                    type: 'set_additional_embedding_data',
                    payload,
                });
            }
            else {
                if (onGo1MessageReceived) {
                    onGo1MessageReceived(rest);
                }
            }
        }
    }, [additionalUserInfo, sendMessageToGo1, onGo1MessageReceived, themeInformation, featureAttributes]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('message', eventListenerInstance);
        return () => {
            window.removeEventListener('message', eventListenerInstance);
        };
    }, [eventListenerInstance]);
    const ContentView = (0, react_1.useCallback)((userProps) => {
        return Go1ContentView(iframeRef, iframeURL, iframeID, userProps);
    }, [iframeRef, iframeURL, iframeID]);
    return { sendMessageToGo1, ContentView };
}
exports.useGo1ContentView = useGo1ContentView;
function Go1ContentView(iframeRef, iframeURL, iframeID, userProps) {
    return (React.createElement("iframe", { id: iframeID, ref: iframeRef, src: iframeURL.toString(), style: { border: 0, width: '100%', height: '100%' }, sandbox: 'allow-popups allow-popups-to-escape-sandbox allow-scripts allow-same-origin allow-forms', ...userProps }));
}
